export default __webpack_public_path__ + "static/media/logo.d6a8ae3e.svg";